var _dec, _dec2, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import I3STraits from "./I3STraits";
import Cesium3DTilesCatalogItemTraits from "./Cesium3DTilesCatalogItemTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let I3SCatalogItemTraits = (_dec = traitClass({
  description: "Creates an I3S item in the catalog from an slpk.",
  example: {
    type: "I3S",
    name: "CoM Melbourne 3D Photo Mesh",
    id: "some-unique-id"
  }
}), _dec2 = primitiveTrait({
  name: "Token",
  description: "Token to use for ArcGIS REST API requests",
  type: "string"
}), _dec(_class = (_class2 = class I3SCatalogItemTraits extends mixTraits(Cesium3DTilesCatalogItemTraits, I3STraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "token", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "token", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { I3SCatalogItemTraits as default };